import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

const _7e03da1e = () => interopDefault(import('../pages/monitoring.vue'
/* webpackChunkName: "pages/monitoring" */
));

const _e1b38a3c = () => interopDefault(import('../pages/redirect_url.vue'
/* webpackChunkName: "pages/redirect_url" */
));

const _6e70e060 = () => interopDefault(import('../pages/tools/grid.vue'
/* webpackChunkName: "pages/tools/grid" */
));

const _cf8d1c40 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "pages/_market/_language/index" */
));

const _79b8e485 = () => interopDefault(import('../pages/_market/_language/cart/index.vue'
/* webpackChunkName: "pages/_market/_language/cart/index" */
));

const _1b5d4366 = () => interopDefault(import('../pages/_market/_language/help/index.vue'
/* webpackChunkName: "pages/_market/_language/help/index" */
));

const _609c738c = () => interopDefault(import('../pages/_market/_language/login/index.vue'
/* webpackChunkName: "pages/_market/_language/login/index" */
));

const _268f21f4 = () => interopDefault(import('../pages/_market/_language/sitemap/index.vue'
/* webpackChunkName: "pages/_market/_language/sitemap/index" */
));

const _4265a98a = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "pages/_market/_language/store-locator/index" */
));

const _da8e8920 = () => interopDefault(import('../pages/_market/_language/user/index.vue'
/* webpackChunkName: "pages/_market/_language/user/index" */
));

const _86fbe958 = () => interopDefault(import('../pages/_market/_language/help/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/confirm" */
));

const _ef14ca80 = () => interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
/* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
));

const _24f01b13 = () => interopDefault(import('../pages/_market/_language/poc/grid.vue'
/* webpackChunkName: "pages/_market/_language/poc/grid" */
));

const _27a8d15e = () => interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
/* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
));

const _62f68bde = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "pages/_market/_language/s/home-by-me" */
));

const _600183ec = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "pages/_market/_language/s/lighting" */
));

const _e7e07146 = () => interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
/* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
));

const _d1584a50 = () => interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-cards" */
));

const _513703fa = () => interopDefault(import('../pages/_market/_language/user/orders/index.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/index" */
));

const _7e20a172 = () => interopDefault(import('../pages/_market/_language/user/profile.vue'
/* webpackChunkName: "pages/_market/_language/user/profile" */
));

const _33d7648a = () => interopDefault(import('../pages/_market/_language/user/profile/index.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/index" */
));

const _356e814c = () => interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
));

const _dea998e2 = () => interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
));

const _880261b0 = () => interopDefault(import('../pages/_market/_language/user/profile/FormAddress.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/FormAddress" */
));

const _30fe9cda = () => interopDefault(import('../pages/_market/_language/user/profile/password.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/password" */
));

const _05147f17 = () => interopDefault(import('../pages/_market/_language/user/wishlist.vue'
/* webpackChunkName: "pages/_market/_language/user/wishlist" */
));

const _b63bbe1c = () => interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
));

const _8a00cdca = () => interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
));

const _04ecd6f0 = () => interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/contact/_form" */
));

const _70feb910 = () => interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
/* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
));

const _c5f17fc0 = () => interopDefault(import('../pages/_market/_language/help/return/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/return/_form" */
));

const _10fdbed4 = () => interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
));

const _6b1f5542 = () => interopDefault(import('../pages/_market/_language/c/_alias.vue'
/* webpackChunkName: "pages/_market/_language/c/_alias" */
));

const _0c73705c = () => interopDefault(import('../pages/_market/_language/configurator/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/_model" */
));

const _15ef11a6 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
));

const _2a36c439 = () => interopDefault(import('../pages/_market/_language/p/_slug.vue'
/* webpackChunkName: "pages/_market/_language/p/_slug" */
));

const _3db22d6a = () => interopDefault(import('../pages/_market/_language/q/_keyword.vue'
/* webpackChunkName: "pages/_market/_language/q/_keyword" */
));

const _367388d0 = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
));

const _d3e9a946 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "" */
));

const _63bd6b49 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "" */
));

const _52a6eaad = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "" */
));

const _4b34c87e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "" */
));

const _3cb0debb = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "" */
));

const _4aca05f8 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "" */
));

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual';
    });
  }
}

const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(r => r.components.default.options.scrollToTop !== false)) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _7e03da1e,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _e1b38a3c,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _6e70e060,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _cf8d1c40,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _79b8e485,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _1b5d4366,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _609c738c,
      name: "market-language-login"
    }, {
      path: "/:market/:language/sitemap",
      component: _268f21f4,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _4265a98a,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _da8e8920,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _86fbe958,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _ef14ca80,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/poc/grid",
      component: _24f01b13,
      name: "market-language-poc-grid"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _27a8d15e,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _62f68bde,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _600183ec,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _e7e07146,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _d1584a50,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _513703fa,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _7e20a172,
      children: [{
        path: "",
        component: _33d7648a,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _356e814c,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _dea998e2,
        name: "market-language-user-profile-alerts"
      }, {
        path: "FormAddress",
        component: _880261b0,
        name: "market-language-user-profile-FormAddress"
      }, {
        path: "password",
        component: _30fe9cda,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _05147f17,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _b63bbe1c,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _8a00cdca,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _04ecd6f0,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _70feb910,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _c5f17fc0,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _10fdbed4,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _6b1f5542,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _0c73705c,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _15ef11a6,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/p/:slug?",
      component: _2a36c439,
      name: "market-language-p-slug"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _3db22d6a,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _367388d0,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}